module.exports = __webpack_public_path__ + "img/abalt.881f9b37.png";